import React from 'react';
import PropTypes from 'prop-types';
import EnvironmentSensorsHeader from './EnvironmentSensorsHeaderComponent';
import EnvironmentSensorsRow from './EnvironmentSensorsRowComponent';
import { isEmpty } from 'lodash';

const ConnectedAssetsEnvironmentSensorsComponent = ({ gatewayConnectedEnvironmentSensorData, gatewayID }) => {
    return (
        <div className='environment-sensor-list'>
            <div className='environment-sensor-list__body'>
                {!isEmpty(gatewayConnectedEnvironmentSensorData) && <EnvironmentSensorsHeader />}
                <EnvironmentSensorsRow gatewayConnectedEnvironmentSensorData={gatewayConnectedEnvironmentSensorData} gatewayID={gatewayID} />
            </div>
        </div>
    );
};

ConnectedAssetsEnvironmentSensorsComponent.propTypes = {
    gatewayConnectedEnvironmentSensorData: PropTypes.object,
    searchQuery: PropTypes.string,
    gatewayID: PropTypes.number
};

export default ConnectedAssetsEnvironmentSensorsComponent;
